<template>
  <div class="apply_collection">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_div_apply_collection">
          <div class="security_main_body_div_H1_apply_collection">网页数据采集</div>
          <div class="security_main_body_div_text">
            帮助您解决频繁验证码和网络访问异常等问题，提高数据采集的效率和准确性，实现高效、规模化数据采集，节省时间和人力成本
          </div>
          <div class="security_main_body_div_butts_apply_collection">
            <div
              class="security_main_body_div_butt div_buttA"
              @click="loginshow"
            >
              免费试用
            </div>
            <div class="security_main_body_div_butt div_buttB" @click="topay">
              产品价格
            </div>
          </div>
          <div class="apply_collection_dzsw_d4_collection">
            <div>
              <img src="http://apiupss.ppfly.top/images/banner_icon1.svg" alt="" />
              <div>全球地区覆盖</div>
            </div>
            <div>
              <img src="http://apiupss.ppfly.top/images/banner_icon2.svg" alt="" />
              <div>99.9%业务成功率</div>
            </div>
            <div>
              <img src="http://apiupss.ppfly.top/images/banner_icon3.svg" alt="" />
              <div>精准定位州/城市</div>
            </div>
            <div>
              <img
                style="width: 60px"
                src="http://apiupss.ppfly.top/images/banner_icon6.png"
                alt=""
              />
              <div>HTTP(S)/Socks5协议</div>
            </div>
          </div>
        </div>

        <div class="security_main_body_divB_coll">
          <div class="security_main_body_divB_div">
            <div class="security_main_body_divB_div_left">
              <div>
                <div class="security_main_body_divB_div_left_H1">
                  大规模数据采集
                </div>
                <div class="security_main_body_divB_div_left_text">
                  掌握全球网络数据资源，从数千万网页中提取有价值的信息进行分析，为您的业务决策提供数据支持
                </div>
              </div>
              <div style="display: flex; justify-content:left;">
                <div>
                  <div class="applyele_list_img" style="margin-right: 70px;">
                    <div>
                      <img src="http://apiupss.ppfly.top/images/tip_icon2.svg" alt="" />
                    </div>
                    <div>
                      <div>获取实时数据</div>
                    </div>
                  </div>
                  <div class="applyele_list_img">
                    <div>
                      <img src="http://apiupss.ppfly.top/images/tip_icon2.svg" alt="" />
                    </div>
                    <div>
                      <div>竞争对手情报</div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="applyele_list_img">
                    <div>
                      <img src="http://apiupss.ppfly.top/images/tip_icon2.svg" alt="" />
                    </div>
                    <div>
                      <div>洞察市场趋势</div>
                    </div>
                  </div>
                  <div class="applyele_list_img">
                    <div>
                      <img src="http://apiupss.ppfly.top/images/tip_icon2.svg" alt="" />
                    </div>
                    <div>
                      <div>发现潜在客户</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="security_main_body_divB_div_reft">
              <img src="http://apiupss.ppfly.top/images/introduce_r_8.svg" alt="" />
            </div>
          </div>
        </div>

        <apply_electronic_mainket />
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>
<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
import apply_electronic_mainket from "@/components/apply_electronic_mainket/apply_electronic_mainket.vue";
export default {
  // apply-market
  name: "apply_collection",
  components: {
    Head,
    Footer,
    Xuanfuret,
    apply_electronic_mainket,
  },
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    topay() {
      this.$router
        .push({
          path: "/pay",
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
      this.$router.go(0);
    },
    loginshow() {
      const token = this.$cookies.get("userdata");
      if (token == null) {
        this.$router
          .push({
            path: "/userlogin",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
      }
    },
  },

  created() {},
  mounted() {
    this.totop();
  },
};
</script>
<style lang="scss" scoped>
.security_main_body {
  background-color: #f5f2f23a;
}
.security_main_body_div_apply_collection {
  background: url(http://apiupss.ppfly.top/images/home_banner.76027eb.webp);
  background-color: #edf3fc;
  background-repeat: no-repeat;
  padding-bottom: 200px;
  text-align: left;
  padding-left: 300px;
  // https://oss.kookeey.com/keekooy-next-dist/public/_nuxt/proxy-network_bg.1d9685a0.png
}
.security_main_body_div_H1_apply_collection {
  padding-top: 80px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 54px;
  color: #1b2336;
  line-height: 76px;
}
.security_main_body_div_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  width: 600px;
  font-size: 22px;
  color: rgba(18, 17, 39, 0.72);
  line-height: 40px;
}
.apply_collection_dzsw_d4_collection {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: left;
}
.apply_collection_dzsw_d4_collection > div{
  margin-right: 110px;
}
.apply_collection_dzsw_d4_collection img {
  margin-bottom: 30px;
}
.security_main_body_div_butts_apply_collection {
  display: flex;
  justify-content: left;
  margin: 80px 0 80px 0;
}

.security_main_body_div_butt {
  width: 191px;
  height: 54px;
  border-radius: 45px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  cursor: pointer;
  box-sizing: border-box;
}
.div_buttA {
  background: #3580ff;
  color: #edf3fc;
}
.div_buttB {
  background: transparent;
  border: 1px solid #0e1d3c;
  color: #0e1d3c;
}
.security_main_body_divB_coll {
  margin-top: -100px;
}
.security_main_body_divB_div {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 60px;
  background-color: #edf3fc;
  border-radius: 10px;
}
.security_main_body_divB_div_left {
  width: 50%;
  padding-top: 75px;
}
.security_main_body_divB_div_reft {
  width: 50%;
  margin-top: 60px;
}
.security_main_body_divB_div_left_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 36px;
  color: #1b2336;
  line-height: 40px;
  text-align: left;
}
.security_main_body_divB_div_left_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #565656;
  line-height: 26px;
  margin-top: 34px;
  margin-bottom: 24px;
  text-align: left;
}
.applyele_list_img {
  display: flex;
  justify-content: left;
  margin: 10px 0 10px 0;
}
.applyele_list_img > div {
  text-align: left;
  margin-right: 20px;
}
.applyele_list_img > div:nth-child(1) {
  text-align: left;
  margin-top: 5px;
}
.applyele_list_img_text {
  font-weight: 400;
  font-size: 14px;
  color: #565656;
  margin-top: 5px;
}
</style>
